/**
 * Curated list of well-known neighbourhoods grouped by county.
 * Used by the shared NeighborhoodSelect dropdown across Register,
 * Profile and the Onboarding modal.
 */
export const COUNTY_NEIGHBORHOODS = [
  {
    county: "Nairobi",
    hoods: [
      "Kilimani",
      "Kileleshwa",
      "Lavington",
      "Westlands",
      "Parklands",
      "Riverside",
      "Upper Hill",
      "Karen",
      "Langata",
      "Ngong Road",
      "Kitisuru",
      "Loresho",
      "Runda",
      "Muthaiga",
      "Spring Valley",
      "South B",
      "South C",
      "Nairobi CBD",
      "Eastleigh",
      "Buruburu",
      "Donholm",
      "Umoja",
      "Kayole",
      "Komarock",
      "Embakasi",
      "Pipeline",
      "Utawala",
      "Ruai",
      "Kasarani",
      "Roysambu",
      "Zimmerman",
      "Mathare",
      "Huruma",
      "Dandora",
      "Kariobangi",
      "Kibra",
      "Kawangware",
      "Riruta",
      "Dagoretti",
      "Woodley",
      "Imara Daima",
      "Nyayo Estate",
      "Fedha",
    ],
  },
  {
    county: "Kiambu",
    hoods: [
      "Ruaka",
      "Ruiru",
      "Thika",
      "Juja",
      "Kikuyu",
      "Kiambu Town",
      "Limuru",
      "Karuri",
      "Kabete",
      "Kahawa Sukari",
      "Kahawa Wendani",
      "Kahawa West",
      "Kinoo",
      "Banana",
      "Ndenderu",
      "Tigoni",
      "Kirigiti",
      "Githunguri",
      "Gigiri Ridge",
      "Membley",
      "Gachie",
    ],
  },
  {
    county: "Mombasa",
    hoods: [
      "Nyali",
      "Bamburi",
      "Shanzu",
      "Kisauni",
      "Kongowea",
      "Mkomani",
      "Bombolulu",
      "Utange",
      "Kizingo",
      "Tudor",
      "Old Town",
      "Mvita",
      "Mwembe Tayari",
      "Likoni",
      "Mtongwe",
      "Changamwe",
      "Miritini",
      "Mikindani",
      "Port Reitz",
      "Jomvu",
    ],
  },
];

export const ALL_NEIGHBORHOODS = COUNTY_NEIGHBORHOODS.flatMap((c) => c.hoods);
